import { render, staticRenderFns } from "./WordleGame.vue?vue&type=template&id=13dab55f"
import script from "./WordleGame.vue?vue&type=script&lang=js"
export * from "./WordleGame.vue?vue&type=script&lang=js"
import style0 from "./WordleGame.vue?vue&type=style&index=0&id=13dab55f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports